import { useMemo } from "react";

interface SnowProps {
  count?: number;
}

/**
 * Lightweight CSS snow. Replaces the three.js particle system so the
 * landing page no longer needs a WebGL context just for falling snow.
 */
function Snow({ count = 60 }: SnowProps) {
  const flakes = useMemo(
    () =>
      Array.from({ length: count }, (_, i) => ({
        id: i,
        left: Math.random() * 100,
        size: 1.5 + Math.random() * 3.5,
        duration: 9 + Math.random() * 14,
        delay: -Math.random() * 25,
        drift: (Math.random() - 0.5) * 120,
        opacity: 0.25 + Math.random() * 0.5,
        blur: Math.random() > 0.75 ? 1.2 : 0,
      })),
    [count],
  );

  return (
    <div className="snow" aria-hidden="true">
      {flakes.map((f) => (
        <span
          key={f.id}
          className="snow-flake"
          style={
            {
              left: `${f.left}%`,
              width: `${f.size}px`,
              height: `${f.size}px`,
              opacity: f.opacity,
              filter: f.blur ? `blur(${f.blur}px)` : undefined,
              animationDuration: `${f.duration}s`,
              animationDelay: `${f.delay}s`,
              "--drift": `${f.drift}px`,
            } as React.CSSProperties
          }
        />
      ))}
    </div>
  );
}

export default Snow;
